<div class="breadcrumbs mb-3">
  <div class="container">
    <div class="row">
      <div class="column-12">
        <ol class="breadcrumb-list">
          <li>
            <!-- To prevent problems, the breadcrumb does a full refresh on logo click -->
            <a href="/">Odido</a>
          </li>
          @if (breadcrumbs) {
            @for (route of breadcrumbs; track route.url; let isLast = $last) {
              @if (!isLast) {
                <li class="breadcrumb-item">
                  @if (!isMagentaUrl(route.url)) {
                    <a href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
                  } @else {
                    <a [href]="route.url">{{ route.displayName }}</a>
                  }
                </li>
              }
              @if (isLast) {
                <li class="breadcrumb-item active" aria-current="page">
                  <span>{{ route.displayName }}</span>
                </li>
              }
            }
          }
        </ol>
      </div>
    </div>
  </div>
</div>